const Hero = () => {
  const scrollToPrograms = () => {
    const element = document.querySelector('#programs');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center pt-20">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(/assets/images/hero-bg.jpg)',
        }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-black/60 via-black/40 to-black/60"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-primary/20 to-primary-700/20"></div>
      </div>

      {/* Content */}
      <div className="container-custom relative z-10 pt-20 pb-20">
        <div className="text-center max-w-4xl mx-auto">
          {/* Main Heading */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 text-shadow-lg">
            <span className="block text-secondary text-2xl md:text-3xl lg:text-4xl font-semibold mb-2">
              UPOWER GROUP - ONE TEAM - ONE GOAL
            </span>
            <span className="bg-gradient-to-r from-secondary to-secondary-300 bg-clip-text text-transparent">
              KHAI PHÁ TIỀM NĂNG
            </span>
            <br />
            <span className="text-white">KIẾN TẠO THỊNH VƯỢNG CÙNG UPOWER</span>
          </h1>

          {/* Subtitle */}
          <p className="text-lg md:text-xl lg:text-2xl text-gray-200 mb-8 leading-relaxed">
            Với tầm nhìn trở thành Tổ chức khởi nghiệp hàng đầu Việt Nam trong
            lĩnh vực đào tạo{' '}
            <span className="font-semibold text-secondary">Tư duy</span>,{' '}
            <span className="font-semibold text-secondary">
              Phát triển bản thân
            </span>
            , <span className="font-semibold text-secondary">Bán hàng</span>,{' '}
            <span className="font-semibold text-secondary">Marketing</span>,{' '}
            <span className="font-semibold text-secondary">Lãnh đạo</span> &{' '}
            <span className="font-semibold text-secondary">Coaching</span>
          </p>

          {/* Mission Statement */}
          <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 md:p-8 mb-10 shadow-lg border border-primary/20">
            <p className="text-xl md:text-2xl font-semibold text-primary mb-2">
              Sứ mệnh của chúng tôi
            </p>
            <p className="text-lg md:text-xl text-gray-800 font-medium">
              &ldquo;Vì Một Cộng Đồng Sống Có Mục Đích&rdquo;
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={scrollToPrograms}
              className="btn-primary text-lg px-8 py-4 w-full sm:w-auto"
            >
              Khám Phá Các Khóa Học
            </button>
            <button
              onClick={() => {
                const element = document.querySelector('#contact');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="bg-white/90 hover:bg-white text-primary border-2 border-white font-semibold text-lg px-8 py-4 w-full sm:w-auto rounded-lg transition-all duration-300 backdrop-blur-sm"
            >
              Đăng Ký Tư Vấn
            </button>
          </div>

          {/* Stats */}
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-secondary mb-2">
                80,000+
              </div>
              <div className="text-gray-200 font-medium">
                Học viên đã tham gia
              </div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-secondary mb-2">
                10+
              </div>
              <div className="text-gray-200 font-medium">Năm kinh nghiệm</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-secondary mb-2">
                100+
              </div>
              <div className="text-gray-200 font-medium">
                Chương trình đào tạo
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <svg
          className="w-6 h-6 text-primary"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 14l-7 7m0 0l-7-7m7 7V3"
          />
        </svg>
      </div>
    </section>
  );
};

export default Hero;
